import VideoThumbnailButton from './component'
export default VideoThumbnailButton
